export enum InterviewState {
  Scheduled,
  InProgress,
  Completed,
  Canceled,
}
